import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokVideoComponent } from '../../app/content/modules/storyblok/components/storyblok-video/storyblok-video.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokVideoComponent> = {
  title: 'Storyblok/Video',
  component: StoryblokVideoComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok video block. Embeds a YouTube video with cookiebot consent handling.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokVideoComponent>;

export const WithVideoId: Story = {
  args: {
    videoId: 'dQw4w9WgXcQ',
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-video')).toBeTruthy();
  },
};

export const WithUrl: Story = {
  args: {
    url: { url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-video')).toBeTruthy();
  },
};

export const WithUrlAndParams: Story = {
  args: {
    url: { url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ&t=42' },
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-video')).toBeTruthy();
  },
};
